// extracted by mini-css-extract-plugin
export default {"cold_list":"index_cold_list_JmznL","cold_a":"index_cold_a_x4M45"};